import { toaster } from 'uikit/Toaster'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { api } from 'api'

export const useCreateDocument = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (data) => api.documents.createItem(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['documentsList'] })

      toaster.create({
        title: 'Документ успешно создан',
        type: 'success',
        duration: 3000,
      })
    },
    onError: (error) => {
      toaster.create({
        title: 'Ошибка при создании документа',
        description: error.message,
        type: 'error',
        duration: 9000,
      })
    },
  })
}
